import Logo from "../../images/Design3/logo.png";
import Img1 from "../../images/Design3/PopCard.png";
import Img2 from "../../images/Design3/barcode.png";
import { React, useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import { BaseUrl } from "../../helper/Baseurl";
import { Loader } from "react-overlay-loader";
import { useSnackbar } from "notistack";
import { Swiper, SwiperSlide } from "swiper/react";
// import required modules
import { Autoplay } from "swiper";
import { styled } from "styled-components";
import { useMediaQuery } from "@mui/material";

const Design4 = () => {
  const { id } = useParams();
  const matches = useMediaQuery("(max-width:992px)");
  const { enqueueSnackbar } = useSnackbar();
  const [loader, setLoader] = useState(true);
  const [Screen, setScreen] = useState(false);
  const [Data, setData] = useState([]);
  const [popFax, setPopFax] = useState([]);

  const search = () => {
    axios
      .get(`${BaseUrl.localBaseUrl}search/${id}`)
      .then((res) => {
        setPopFax(res.data.result.popFax);
        setData(res.data.result);
        setInterval(setScreen(true), 2000);
        setScreen(true);
        setLoader(false);
      })
      .catch((err) => {
        setLoader(false);
        enqueueSnackbar(err?.data?.message, {
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
          autoHideDuration: 2000,
        });
      });
    };
    
    // console.log(Data)
  useEffect(() => {
    search();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  // 1080 / 1440
  return (
    <>
      {" "}
      {loader ? <Loader fullPage loading /> : null}
      {Screen ? (
        <MainContainer>
          <div className={matches ? "container-fluid" : "container"}>
            <div className="row">
              <div className="col-md-12 d-flex justify-content-between align-items-center">
                <img src={Logo} style={{ width: "28%" }} alt="logo" />
                <Link to="/">
                  <BackButton>BACK TO MAIN MENU</BackButton>
                </Link>
              </div>
            </div>
            <Frame>
              <div className="row justify-content-center">
                <div className="col-12" style={{ maxWidth: "800px" }}>
                  <div className="row">
                    <div className="col-4" style={{ padding: "5px" }}>
                      <ImageCard $borderColor={Data.popPictureBordorColor}>
                        <Swiper
                          centeredSlides={true}
                          speed={900}
                          autoplay={{
                            delay: 2000,
                            disableOnInteraction: false,
                          }}
                          modules={[Autoplay]}
                          className="mySwiper"
                          style={{ width: "100%" }}
                        >
                          {Data?.poppicture?.map((e, i) => (
                            <SwiperSlide
                              style={{ borderRadius: "28px" }}
                              key={i}
                            >
                              <img
                                src={e}
                                className="w-100"
                                style={{ borderRadius: "28px" }}
                                alt="img"
                              />
                            </SwiperSlide>
                          ))}
                        </Swiper>
                      </ImageCard>
                    </div>
                    <div className="col-4" style={{ padding: "5px" }}>
                      <div className="d-flex justify-content-center">
                        <img src={Img1} style={{ width: "115%" }} alt="img" />
                      </div>
                      <div className="d-flex justify-content-center border-color2">
                        <div className="position-relative">
                          <img src={Img2} className="img-fluid" alt="img" />
                          <StickerNumber>{Data?.stickerNumber}</StickerNumber>
                        </div>
                      </div>
                    </div>
                    <div className="col-4" style={{ padding: "5px" }}>
                      <ImageCard $borderColor={Data.popSignerBordorColor}>
                        <Swiper
                          centeredSlides={true}
                          speed={900}
                          autoplay={{
                            delay: 2000,
                            disableOnInteraction: false,
                          }}
                          modules={[Autoplay]}
                          className="mySwiper"
                          style={{ width: "100%" }}
                        >
                          {Data?.popSigner?.map((e, i) => (
                            <SwiperSlide
                              style={{ borderRadius: "28px" }}
                              key={i}
                            >
                              <img
                                src={e?.pop_signer}
                                className="w-100"
                                style={{ borderRadius: "28px" }}
                                alt="img"
                              />
                            </SwiperSlide>
                          ))}
                        </Swiper>
                      </ImageCard>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row justify-content-center mt-3">
                <div className="col-12" style={{ maxWidth: "800px" }}>
                  {/* Funko Pop Details */}
                  <div className="row">
                    <div className="col-4" style={{ padding: "5px" }}>
                      <ContentCard>
                        <div className="cardHeader">Funko Pop Details</div>
                        {[
                          {
                            heading: "Funko Pop Series",
                            value: Data.funkoPopSeries,
                          },
                          {
                            heading: "Funko Pop Number",
                            value: Data.funkoPopNumber,
                          },
                          {
                            heading: "Funko Pop Name",
                            value: Data.funkoPopName,
                          },
                          { heading: "UPC Number", value: Data.upcNumber },
                          { heading: "Box Date Code", value: Data.boxDateCode },
                        ].map((item, index) => (
                          <div key={index}>
                            <div className="mt-3">
                              <p className="heading">{item.heading}</p>
                            </div>
                            <div className="d-flex justify-content-center">
                              <p className="values">{item.value || " "}</p>
                            </div>
                          </div>
                        ))}
                      </ContentCard>
                    </div>

                    {/* Authentication Details */}
                    <div className="col-4" style={{ padding: "5px" }}>
                      <ContentCard>
                        <div className="cardHeader">Authentication Details</div>
                        <div className="row justify-content-center">
                          <div className="col-6" style={{ padding: "5px" }}>
                            {[
                              { heading: "status", value: Data.status },
                              {
                                heading: "Location Signed",
                                value: Data.locationSigned,
                              },
                              {
                                heading: "Signed Affidavit",
                                value: Data.signAffidavit,
                              },
                              {
                                heading: "On Site Witness",
                                value: Data.authenticationWitness?.witness,
                              },
                            ].map((item, index) => (
                              <div key={index}>
                                <div className="mt-3">
                                  <p className="heading">{item.heading}</p>
                                </div>
                                <div className="d-flex justify-content-center">
                                  <p className="values">{item.value || " "}</p>
                                </div>
                              </div>
                            ))}
                          </div>
                          <div className="col-6" style={{ padding: "5px" }}>
                            {[
                              {
                                heading: "Service",
                                value: Data.authenticationService,
                              },
                              {
                                heading: "Date Signed",
                                value: Data.dateSigned,
                              },
                              {
                                heading: "video/Clip",
                                value: Data.videoOrClip ? (
                                  <a
                                    href={Data.videoOrClip}
                                    target="_blank"
                                    rel="noreferrer"
                                  >
                                    CLICK HERE
                                  </a>
                                ) : (
                                  "N/A"
                                ),
                              },
                              {
                                heading: "Gps MetaData",
                                value: Data.gpsMetaData || "N/A",
                              },
                            ].map((item, index) => (
                              <div key={index}>
                                <div className="mt-3">
                                  <p className="heading">{item.heading}</p>
                                </div>
                                <div className="d-flex justify-content-center">
                                  <p className="values">{item.value}</p>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                        <div className="text-center mt-3">
                          <p className="heading">
                            Qualifies for Our $1,000,000 Guarantee
                          </p>
                          <Link to={"/guarantee"} className="values">
                            CLICK HERE
                          </Link>
                        </div>
                      </ContentCard>
                    </div>

                    {/* Signature Details */}
                    <div className="col-4" style={{ padding: "5px" }}>
                      <ContentCard>
                        <div className="cardHeader">Signature Details</div>
                        <div className="mt-3">
                          <p className="heading">Signature Type</p>
                          <div className="d-flex justify-content-center">
                            <p className="values">
                              {Data.signatureType || " "}
                            </p>
                          </div>
                        </div>
                        <div className="mt-3">
                          <p className="heading">Signed by</p>
                          <div className="d-flex justify-content-center">
                            <p className="values">
                              {Data.signer?.map(
                                (e, i, arr) =>
                                  `${arr.length - 1 !== i ? e + ", " : e}`
                              ) || " "}
                            </p>
                          </div>
                        </div>
                      </ContentCard>
                    </div>
                  </div>

                  {/* Second Row */}
                  <div className="row mt-3">
                    {/* Pop Fax */}
                    <div className="col-4" style={{ padding: "5px" }}>
                      <ContentCard>
                        <div className="cardHeader">Pop Fax</div>
                        <div className="mt-3">
                          <p className="heading">Registered Owner</p>
                          <div className="d-flex justify-content-center">
                            <p className="values">{popFax[0].register_owner}</p>
                          </div>
                        </div>
                        <div className="row justify-content-around">
                          <div className="col-6 mt-3">
                            <p className="heading">Purchase Date</p>
                            <p className="values_box2">{popFax[0].date}</p>
                          </div>
                          <div className="col-6 mt-3">
                            <p className="heading">Purchase Price</p>
                            <p className="values_box2">{popFax[0].price}</p>
                          </div>
                        </div>
                        <div className="mt-3">
                          <p className="heading">Previous Ownership History</p>
                          <div className="row">
                            {["Name", "Date", "Amount"].map(
                              (heading, index) => (
                               
                                  <div className="col-4" key={index}>
                                    <p className="heading">{heading}</p>
                                    {/* Display values for the first three entries in popFax */}
                                    {popFax.slice(1, 4).map((p, idx) => (
                                      <p className="values" key={idx}>
                                        {heading === "Name" && p.register_owner}
                                        {heading === "Date" && p.date}
                                        {heading === "Amount" && p.price}
                                      </p>
                                    ))}
                                  </div>
                              
                              )
                            )}
                          </div>
                        </div>
                        <button className="transferButton w-100 mt-3">
                          Submit Or Transfer Ownership
                        </button>
                      </ContentCard>
                    </div>

                    {/* Enhanced Details */}
                    <div className="col-4" style={{ padding: "5px" }}>
                      <ContentCard>
                        <div className="cardHeader">Enhanced Details</div>
                        {[
                          {
                            heading: "Encapsulated",
                            value: Data.encapsulated || "N/A",
                          },
                          { heading: "Graded", value: Data.graded || "N/A" },
                          {
                            heading: "Grade Number",
                            value: Data.gradeNumber || "N/A",
                          },
                        ].map((item, index) => (
                          <div
                            className="row justify-content-center mt-3"
                            key={index}
                          >
                            <div className="col-6">
                              <p className="heading text-start">
                                {item.heading}
                              </p>
                            </div>
                            <div className="col-3">
                              <p className="value_box">{item.value}</p>
                            </div>
                          </div>
                        ))}
                        <div className="mt-3">
                          <p className="heading">Grading Company</p>
                          <p className="values">
                            {Data.gradingCompany || "N/A"}
                          </p>
                        </div>
                        <div className="mt-3">
                          <p className="heading">Grading Report Link</p>
                          <p className="values">
                            {Data.gradingReportLink ? (
                              <a
                                href={
                                  Data.gradingReportLink.includes("https://")
                                    ? Data.gradingReportLink
                                    : "https://" + Data.gradingReportLink
                                }
                                target="_blank"
                                rel="noreferrer"
                              >
                                CLICK HERE
                              </a>
                            ) : (
                              "N/A"
                            )}
                          </p>
                        </div>
                      </ContentCard>
                    </div>

                    {/* Notes */}
                    <div className="col-4" style={{ padding: "5px" }}>
                      <ContentCard>
                        <div className="cardHeader">Notes</div>
                        <div className="mt-3">
                          <p className="noteBox">{Data.quotes}</p>
                          <p className="noteBox">{Data.inscriptions}</p>
                        </div>
                        <div className="text-center mt-3">
                          <img
                            src={Logo}
                            alt="logo"
                            style={{ width: "100%" }}
                          />
                        </div>
                      </ContentCard>
                    </div>
                  </div>
                </div>
              </div>
            </Frame>
            <div className="row mt-3">
              <div className="col-md-12 text-center">
                <img src={"/img/bottom_logo.png"} width={300} alt="img" />
              </div>
            </div>
          </div>
        </MainContainer>
      ) : null}
    </>
  );
};

const MainContainer = styled.div`
  background-image: url(../img/background.jpeg);
  background-size: 100% 100%;
  padding-block: 2rem;
`;

const Frame = styled.div`
  background-image: url(../img/popcoa_frame.png);
  background-size: 100% 100%;
  padding-block: 3rem;
  margin-top: 1rem;
`;

const ImageCard = styled.div`
  width: 100%;
  min-height: 300px;
  border-radius: 30px;
  border: 3px solid;
  border-color: ${(props) =>
    props.$borderColor ? props.$borderColor : "#000"};
  background-color: #ffffff;

  @media (min-width: 1440px) {
    min-height: 350px;
  }

  @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {
    min-height: auto;
  }
`;

const BackButton = styled.button`
  background-color: #db1e90 !important;
  color: #ffea4c;
  font-size: 15px !important;
  border-radius: 10px;
  font-family: Gotham-Bold;
  letter-spacing: 0.1px;
  padding: 12px;
  border: none;
`;

const ContentCard = styled.div`
  background-size: cover;
  // height: 100%;
  min-height: 410px;
  position: relative;
  border: solid 2px transparent; /* !importanté */
  border-radius: 1em;
  background: linear-gradient(#000, #000) padding-box,
    linear-gradient(to bottom, #2e77ce, #e4148f) border-box;
  border-radius: 1rem;
  border: 4px solid transparent;

  .cardHeader {
    font-family: "Bebas Kai";
    font-size: 18px;
    // font-style: italic;
    // font-weight: 600;
    background-color: #2e77ce;
    color: #fff;
    text-align: center;
  }

  .heading {
    text-decoration: underline;
    font-family: "Bebas Kai";
    font-size: 14px;
    // font-weight: 600;
    color: #f0f0f0;
    letter-spacing: 1px;
    text-align: center;
    margin: 0;
  }

  .values {
    font-family: "Bebas Kai";
    // color: #FEEB08;
    color: #c8cb0c;
    text-align: center;
    margin: 0;
  }

  .value_box {
    font-family: "Bebas Kai";
    // background-color: #FEEB08;
    background-color: #c8cb0c;
    color: #000;
    text-align: center;
  }

  .values_box2 {
    font-family: "Bebas Kai";
    background-color: #b61774;
    color: #c8cb0c;
    text-align: center;
  }

  .noteBox {
    background-color: #fff;
    color: #000;
    min-height: 100px;
    border-radius: 1rem;
    font-family: "Bebas Kai";
    font-size: 14px;
    text-align: center;
    padding: 0.3rem;
  }

  .transferButton {
    text-transform: uppercase;
    font-family: "Bebas Kai";
    // background-color: #FEEB08;
    background-color: #c8cb0c;
    color: #000;
    text-align: center;
    outline: none;
    border: none;
    border-radius: 1rem;
  }

  @media only screen and (min-device-width: 1400px) {
    min-height: 380px;
  }

  @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {
    min-height: 520px;
  }

  @media only screen and (min-device-width: 1024px) and (max-device-width: 1366px) and (orientation: portrait) {
    min-height: 415px;
  }
`;
const StickerNumber = styled.span`
  position: absolute;
  right: 17.5%;
  top: 63%;
  font-family: Gotham Black;
  text-transform: uppercase;
  background: linear-gradient(
    to right,
    #f5bdfc,
    #f8f8bf,
    #dafec4,
    #bcffee,
    #e5bcfc
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-size: 20px;

  @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {
    right: 12.5%;
    top: 60%;
  }
`;
export default Design4;
